// extracted by css-extract-rspack-plugin
export default {"codeFileContents":"CodeLinesSSR-module__codeFileContents__ARmAN","viewRemainderLink":"CodeLinesSSR-module__viewRemainderLink__pd3EU"};